import { createContext, useContext } from "react";

export type RequestFormMode = "quote" | "quick";

const RequestFormModeContext = createContext<RequestFormMode>("quote");

export const RequestFormModeProvider = RequestFormModeContext.Provider;

export const useRequestFormMode = () => useContext(RequestFormModeContext);

export const useIsQuickRequest = () => useRequestFormMode() === "quick";
